import { render } from "./matCode.vue?vue&type=template&id=1206ccf4&scoped=true"
import script from "./matCode.vue?vue&type=script&lang=js"
export * from "./matCode.vue?vue&type=script&lang=js"

import "./matCode.vue?vue&type=style&index=0&id=1206ccf4&lang=scss"
import "./matCode.vue?vue&type=style&index=1&id=1206ccf4&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1206ccf4"]])

export default __exports__